import { initPushMessaging } from "./push-messaging";
import { initStatusBar } from "./status-bar";

export async function initializeApp() {
  // Initialize push messaging and status bar in parallel
  await Promise.all([
    initPushMessaging().catch(() => {
      console.warn("⚠️ Push messaging init failed");
    }), // ignore push errors
    initStatusBar(),
  ]);
} 